import type { ReceiptTemplate } from '../schema';

export const rolexTemplate: ReceiptTemplate = {
  id: 'rolex',
  name: 'Rolex Receipt',
  brand: 'ROLEX',
  description: 'Luxury watch receipt template inspired by Rolex authorized dealers',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'rolex-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/rolex.png',
        logoData: '',
        logoWidth: 120,
        logoHeight: 60,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'ROLEX BOUTIQUE',
          '1200 Dark Avenue',
          'Monsterville, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'rolex-authorized',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'OFFICIAL ROLEX RETAILER',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'rolex-receipt-info',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'rolex-receipt-num', label: 'Receipt:', value: 'RX-2025-004782' },
          { id: 'rolex-date', label: 'Date:', value: '01/04/2026' },
          { id: 'rolex-time', label: 'Time:', value: '14:32:18' },
          { id: 'rolex-associate', label: 'Associate:', value: 'James S.' },
        ],
        column2: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'rolex-item-header',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '─────────── ITEM ───────────',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
    {
      id: 'rolex-item',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Rolex Submariner Date\nOystersteel, Black Dial\nModel: 126610LN\nSerial: 7X4R9K2M\nRef: M126610LN-0001',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
    {
      id: 'rolex-item-price',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        labelAlignment: 'left',
        lines: [
          { id: 'rolex-price', label: 'Price', value: '10,650.00', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'rolex-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        labelAlignment: 'left',
        lines: [
          { id: 'rolex-subtotal', label: 'Subtotal', value: '10,650.00', isBold: false, isLarge: false },
          { id: 'rolex-tax', label: 'Tax (8.875%)', value: '945.19', isBold: false, isLarge: false },
          { id: 'rolex-total', label: 'TOTAL', value: '11,595.19', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'rolex-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'rolex-method', label: 'Payment', value: 'VISA' },
          { id: 'rolex-card', label: 'Card', value: '************4144' },
          { id: 'rolex-auth', label: 'Auth Code', value: '847291' },
          { id: 'rolex-status', label: 'Status', value: 'APPROVED' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'rolex-warranty',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '── WARRANTY INFORMATION ──\n\nThis Rolex timepiece includes a\n5-year international warranty.\nPlease retain this receipt\nas proof of purchase.',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'rolex-return',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Returns accepted within 14 days\nwith original packaging.',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'rolex-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: 'RX2025004782',
        showValue: true,
        width: 1.5,
        height: 45,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'rolex-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Thank you for choosing Rolex.',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

